import { DATES } from 'const/filters'
import { formatDateFromFilter } from 'helpers/utils'
import { FiltersState } from 'types'

interface AsinUsageParams {
    report_date_min?: string
    report_date_max?: string
}

export const formatAsinUsageFilterParams = (
    filters: FiltersState,
    _hasHourlyData = false,
    fiscalYearStartMonth?: number
): AsinUsageParams => {
    const params: AsinUsageParams = {}

    const dates = filters[DATES]
    const { start, end } = formatDateFromFilter(
        dates,
        undefined,
        undefined,
        fiscalYearStartMonth
    )

    if (!!start && !!end) {
        params.report_date_min = start
        params.report_date_max = end
    }

    return params
}
